<template>
  <div class="issues-app-chat-sidebar">
    <vue-perfect-scrollbar class="issues-app-chat-sidebar__content">

      <div class="issues-app-chat-sidebar__buttons">
        <div class="issues-app-chat-sidebar__button">
          <app-button type="border" @click="$router.go(-1)">Вернуться к заявкам</app-button>
        </div>
      </div>

      <chat-sidebar-card color="warning" class="issues-app-chat-sidebar__card">
        <span slot="header">Статус заявки</span>
        <app-v-select :options="Object.values(statuses)" :reduce-function="option => option.id" use-dynamic-key
                      :clearable="false"
                      :searchable="false" v-model="status">
          <template slot="selected-option" slot-scope="option">
            <div style="display: flex; align-items: center;">
              <div style="width: 14px; height: 14px; margin-right: 15px; border-radius: 50%; flex-shrink: 0;"
                   :style="{backgroundColor: option.color}"></div>
              {{ option.name }}
            </div>
          </template>
          <template slot="option" slot-scope="option">
            <div style="display: flex; align-items: center;">
              <div style="width: 14px; height: 14px; margin-right: 15px; border-radius: 50%;flex-shrink: 0;"
                   :style="{backgroundColor: option.color}"></div>
              {{ option.name }}
            </div>
          </template>
          <template slot="no-options">
            Произошла ошибка
          </template>
        </app-v-select>
      </chat-sidebar-card>

      <chat-sidebar-card color="info" class="issues-app-chat-sidebar__card">
        <span slot="header">Заявка <span style="font-weight: 600">№{{ selectedTask.id }}</span> от <span
          style="font-weight: 600">{{
            selectedTask.created_at | moment($moment(selectedTask.created_at).startOf('day').format('DD.MM.YYYY HH:mm:ss') !== $moment(selectedTask.created_at).format('DD.MM.YYYY HH:mm:ss') ? 'DD.MM.YYYY HH:mm:ss' : 'DD.MM.YYYY')
          }}</span></span>

        <div class="issues-app-chat-sidebar__user-info">
          <label class="issues-app-chat-sidebar__user-info-label">Автор</label>
          <div class="issues-app-chat-sidebar__user-info-body">
            <app-avatar :img="$options.filters.imgPath(selectedTask.owner.avatar)" :name="selectedTask.owner.name"
                        class="issues-app-chat-sidebar__user-info-avatar" size="35px" />
            <div>
              <div class="issues-app-chat-sidebar__user-info-name">{{ selectedTask.owner.name }}</div>
              <div class="issues-app-chat-sidebar__user-info-count">
                Всего заявок: {{ ownerTasksTotalCount }} ({{ ownerTasksThisMonthCount }}
                {{ declOfNum(ownerTasksThisMonthCount, ['заявка', 'заявки', 'заявок']) }} за текущий месяц)
              </div>
              <div class="issues-app-chat-sidebar__user-info-count">
                <span class="link-icon" @click="goToUserIssues">Посмотреть заявки пользователя</span>
              </div>
            </div>
          </div>
        </div>

        <div class="issues-app-chat-sidebar__user-info">
          <label class="issues-app-chat-sidebar__user-info-label">Ответственный</label>
          <div class="issues-app-chat-sidebar__user-info-body">
            <app-v-select :options="users" :reduce="option => option.id" use-dynamic-key
                          :clearable="false"
                          :searchable="false" v-model="manager" style="width: 100%"
                          class="issues-app-chat-sidebar__info-select">
              <template slot="selected-option" slot-scope="option">
                <div style="display: flex; align-items: center;">
                  <app-avatar v-if="option.avatar" :img="$options.filters.imgPath(option.avatar)" :name="option.name"
                              class="issues-app-chat-sidebar__user-info-avatar" size="35px" />
                  <div class="issues-app-chat-sidebar__user-info-name"
                       :class="{'issues-app-chat-sidebar__user-info-name_danger' : option.isUserEmpty}">
                    {{ option.name }}
                  </div>
                </div>
              </template>
              <template slot="option" slot-scope="option">
                <div style="display: flex; align-items: center;">
                  <app-avatar :img="$options.filters.imgPath(option.avatar)" :name="option.name"
                              class="issues-app-chat-sidebar__user-info-avatar" size="20px" />
                  <div class="issues-app-chat-sidebar__user-info-name">{{ option.name }}</div>
                </div>
              </template>
              <template slot="no-options">
                Произошла ошибка
              </template>
            </app-v-select>
          </div>
        </div>

        <div class="issues-app-chat-sidebar__user-info">
          <label class="issues-app-chat-sidebar__user-info-label">Исполнитель</label>
          <div class="issues-app-chat-sidebar__user-info-body">
            <app-v-select :options="users" :reduce-function="option => option.id" use-dynamic-key
                          :clearable="false"
                          :searchable="false" v-model="performer" style="width: 100%"
                          class="issues-app-chat-sidebar__info-select">
              <template slot="selected-option" slot-scope="option">
                <div style="display: flex; align-items: center;">
                  <app-avatar v-if="option.avatar" :img="$options.filters.imgPath(option.avatar)" :name="option.name"
                              class="issues-app-chat-sidebar__user-info-avatar" size="35px" />
                  <div class="issues-app-chat-sidebar__user-info-name"
                       :class="{'issues-app-chat-sidebar__user-info-name_danger' : option.isUserEmpty}">
                    {{ option.name }}
                  </div>
                </div>
              </template>
              <template slot="option" slot-scope="option">
                <div style="display: flex; align-items: center;">
                  <app-avatar :img="$options.filters.imgPath(option.avatar)" :name="option.name"
                              class="issues-app-chat-sidebar__user-info-avatar" size="20px" />
                  <div class="issues-app-chat-sidebar__user-info-name">{{ option.name }}</div>
                </div>
              </template>
              <template slot="no-options">
                Произошла ошибка
              </template>
            </app-v-select>
          </div>
        </div>

      </chat-sidebar-card>

      <chat-sidebar-card color="danger" class="issues-app-chat-sidebar__card">
        <span slot="header">Описание</span>
        {{ selectedTask.description }}
      </chat-sidebar-card>

      <chat-sidebar-card class="issues-app-chat-sidebar__card issues-app-chat-sidebar__card_info">
        <div class="issues-app-chat-sidebar__info-row">
          <div class="issues-app-chat-sidebar__info-row-label">Категория:</div>
          <div class="issues-app-chat-sidebar__info-row-value">
            <app-v-select :options="Object.values(categories)" :reduce-function="option => option.id" use-dynamic-key
                          :clearable="false"
                          :searchable="false" v-model="category" class="issues-app-chat-sidebar__info-select">
              <template slot="selected-option" slot-scope="option">
                <div class="issues-app-chat-sidebar__options-selected">
                  {{ option.name }}
                </div>
              </template>
              <template slot="option" slot-scope="option">
                <div>
                  {{ option.name }}
                </div>
              </template>
              <template slot="no-options">
                Произошла ошибка
              </template>
            </app-v-select>
          </div>
        </div>

        <div class="issues-app-chat-sidebar__info-row" v-if="selectedTask.rate !== null">
          <div class="issues-app-chat-sidebar__info-row-label">Оценка:</div>
          <div class="issues-app-chat-sidebar__info-row-value">
            <star-rating :rating="Number(selectedTask.rate)" :show-rating="false" :star-size="20" :read-only="true"
                         :key="`rating-${selectedTask.rate}`" />
          </div>
        </div>

        <div class="issues-app-chat-sidebar__info-row" v-if="selectedTask.owner && selectedTask.owner.telephone">
          <div class="issues-app-chat-sidebar__info-row-label">Телефон автора:</div>
          <div class="issues-app-chat-sidebar__info-row-value">
            {{ selectedTask.owner.telephone }}
          </div>
        </div>

        <div class="issues-app-chat-sidebar__info-row" v-if="additional.phone">
          <div class="issues-app-chat-sidebar__info-row-label">Телефон для связи:</div>
          <div class="issues-app-chat-sidebar__info-row-value">
            {{ additional.phone }}
          </div>
        </div>
      </chat-sidebar-card>

      <chat-sidebar-card class="issues-app-chat-sidebar__card issues-app-chat-sidebar__card_info">
        <div>
          <div class="issues-app-chat-sidebar-comments__label">
            Внутренние комментарии
          </div>
          <div class="issues-app-chat-sidebar__comments issues-app-chat-sidebar-comments">
            <div class="issues-app-chat-sidebar-comments__toolbar">
              <div :id="`toolbar-container-1-${_uid}`">
                <div>
                  <button class="ql-bold" />
                  <button class="ql-italic" />
                  <button class="ql-underline" />
                </div>

                <div class="issues-app-chat-sidebar-comments__toolbar-button" @click.stop="saveComment">
                  <app-icon name="SaveIcon" size="18px" style="stroke: currentColor; stroke-width: 20" />
                </div>
              </div>
              <div style="text-align: center">
              <span style="font-size: 10px">
                <span style="font-weight: 500;">Ctrl+Enter</span> сохраняет комментарий
              </span>
              </div>
            </div>

            <quill-editor :options="quillEditorOptions"
                          ref="quill"
                          v-model="additional.comments"
                          placeholder="Комментарий пуст"
                          @keydown.ctrl.enter.native.capture.prevent="saveComment"
            />
          </div>
        </div>
      </chat-sidebar-card>

      <chat-sidebar-card class="issues-app-chat-sidebar__card issues-app-chat-sidebar__card_info" v-if="status === 6">
        <div>
          <div class="issues-app-chat-sidebar-comments__label">
            Произведенные действия
          </div>
          <div class="issues-app-chat-sidebar__comments issues-app-chat-sidebar-comments">
            <div class="issues-app-chat-sidebar-comments__toolbar">
              <div :id="`toolbar-container-2-${_uid}`">
                <div>
                  <button class="ql-bold" />
                  <button class="ql-italic" />
                  <button class="ql-underline" />
                </div>

                <div class="issues-app-chat-sidebar-comments__toolbar-button" @click.stop="saveComment">
                  <app-icon name="SaveIcon" size="18px" style="stroke: currentColor; stroke-width: 20" />
                </div>
              </div>
              <div style="text-align: center">
              <span style="font-size: 10px">
                <span style="font-weight: 500;">Ctrl+Enter</span> сохраняет изменения
              </span>
              </div>
            </div>

            <quill-editor :options="quillEditorOptions1"
                          ref="quill"
                          v-model="additional.doneActions"
                          placeholder="Комментарий пуст"
                          @keydown.ctrl.enter.native.capture.prevent="saveComment"
            />
          </div>
        </div>
      </chat-sidebar-card>

      <chat-sidebar-card
        class="issues-app-chat-sidebar__card issues-app-chat-sidebar__card_info"
        v-if="selectedTask.history.length"
      >
        <history-item v-for="historyItem in selectedTask.history" :key="historyItem.id" :item="historyItem" />
      </chat-sidebar-card>
    </vue-perfect-scrollbar>

    <DoneActionsPopup ref="doneActionsPopup" @save="saveDoneMessage" />
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { quillEditor }     from 'vue-quill-editor';
// import StarRating          from 'vue-star-rating';
import HistoryItem         from "@/components/common/issues/info-sidebar/HistoryItem";
import ChatSidebarCard     from "./ChatSidebarCard";
import DoneActionsPopup    from "@/components/employee/tasks/DoneActionsPopup";
import declOfNum           from "@/functions/declOfNum";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name:       "ChatSidebar",
  components: {
    HistoryItem,
    quillEditor,
    ChatSidebarCard,
    // StarRating,
    VuePerfectScrollbar,
    DoneActionsPopup,
  },
  props:      {
    selectedTask: {},
  },
  data() {
    return {
      users:               [],
      declOfNum:           declOfNum,
      quillEditorOptions:  {
        root:       {
          spellcheck: false,
        },
        modules:    {
          toolbar: `#toolbar-container-1-${this._uid}`,
        },
        grammar:    {
          checkSpelling: false,
        },
        spellcheck: false,
      },
      quillEditorOptions1: {
        root:       {
          spellcheck: false,
        },
        modules:    {
          toolbar: `#toolbar-container-2-${this._uid}`,
        },
        grammar:    {
          checkSpelling: false,
        },
        spellcheck: false,
      },
    };
  },
  computed:   {
    ownerTasksTotalCount() {
      return this.selectedTask.owner.task_count === undefined ? 0 : Number(this.selectedTask.owner.task_count);
    },
    ownerTasksThisMonthCount() {
      return this.selectedTask.owner.task_thismonth_count === undefined ? 0 : Number(this.selectedTask.owner.task_thismonth_count);
    },
    categories() {
      return Object.values(this.$store.getters['common/tasks/newCategories']);
    },
    statuses() {
      return Object.values(this.$store.getters['common/tasks/statuses']);
    },
    status:    {
      get() {
        return this.selectedTask.status_id || null;
      },
      set( value ) {
        this.saveTask({ status_id: value });
      },
    },
    category:  {
      get() {
        return this.$store.getters['common/tasks/categoryById'](this.selectedTask.category_id);
      },
      set( value ) {
        this.saveTask({ category_id: value });
      },
    },
    performer: {
      get() {
        return this.selectedTask.performer === null ? {
          name:        'Не назначен',
          isUserEmpty: true,
        } : this.selectedTask.performer;
      },
      set( value ) {
        this.saveTask({ performer_id: value });
      },
    },
    manager:   {
      get() {
        return this.selectedTask.manager === null ? {
          name:        'Не назначен',
          isUserEmpty: true,
        } : this.selectedTask.manager;
      },
      set( value ) {
        this.saveTask({ manager_id: value });
      },
    },
    additional() {
      return this.selectedTask.additional ? JSON.parse(this.selectedTask.additional) : {};
    },

    // category() {
    //   return this.$store.getters['common/tasks/categoryById'](this.selectedTask.category_id);
    // },
  },
  methods:    {
    goToUserIssues() {
      this.$router.push({
        name:  'uc_issues',
        query: {
          users_id: ['' + this.selectedTask.owner.id],
          // type: 'all'
        },
      });
    },
    async getUsers() {
      if (this.selectedTask.id) {
        try {
          let params = {
            buildings_id: this.selectedTask.buildings_id,
          };

          let { data } = await this.$http.get('permission_houses/' + this.selectedTask.buildings_id, {
            params: params,
          });
          this.users = data;
        } catch (e) {
          this.users = [];
        }
      } else {
        this.users = [];
      }
    },
    async saveTask( task ) {
      task = Object.assign(this.selectedTask, task);
      await this.$http.put('tasks/' + task.id, task);
      this.$emit('update-task');
    },
    saveComment() {
      this.saveTask({ additional: JSON.stringify(this.additional) });
    },
    saveDoneMessage( message ) {
      this.saveTask({ additional: JSON.stringify(Object.assign({}, this.additional, { doneActions: message })) });
    },
    openDoneActionsPopup() {
      this.$refs.doneActionsPopup.open();
    },
  },
  mounted() {
    this.getUsers();
  },
  watch:      {
    status() {
      if (this.status === 6) {
        this.openDoneActionsPopup();
      }
    },
  },
};
</script>

<style lang="scss">
.issues-app-chat-sidebar {

  &__buttons {
    text-align: center;
    margin-bottom: 15px;
  }

  &__button {
    display: inline-block;
  }

  &__content {
    background: #fff;
    border: 1px solid #dae1e7;
    box-shadow: 0 1px 6px 1px rgba(69, 65, 78, .1);
    padding: 10px;
    height: 100%;
  }

  &__card {
    margin-bottom: 15px;

    &_info {
      .issues-app-chat-sidebar-card__body {
        padding-bottom: 0;
        padding-top: 0;
      }
    }
  }

  &__user-info {

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    &-label {
      display: block;
      color: rgb(152, 185, 197);
      margin-bottom: 10px;
      line-height: 1;
    }

    &-body {
      display: flex;
      align-items: center;
      padding-left: 5px;
    }

    &-avatar {
      margin-right: 10px;
      flex-shrink: 0;
    }

    &-name {
      color: rgb(0, 140, 233);
      font-weight: 500;
      font-size: 15px;
      line-height: 1.1;

      &_danger {
        color: rgba(var(--app-danger), 1);
      }
    }

    &-count {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.1;
      color: rgba(var(--app-heading-color), 1);
      margin-top: 2px;
    }
  }

  &__info-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;


    &-label {
      display: block;
      padding-right: 5px;
      width: 160px;
      font-weight: 500;
    }

    &-value {
      color: rgb(0, 140, 233);
      font-weight: 500;
      line-height: 1.1;
      flex: 1;
    }
  }

  &__select_no-border {
    .vs__dropdown-toggle {
      border: none !important;
    }
  }

  &__info-select {
    width: 100%;

    .vs__dropdown-toggle {
      border: none !important;
      padding: 0 !important;
      min-height: 0 !important;
    }

    .vs__selected,
    .vs__search {
      padding: 0 !important;
    }

    .vs__actions {
      display: none !important;
    }
  }

  &__options-selected {
    color: rgb(0, 140, 233);
    font-weight: 500;
    line-height: 1.1;
  }

}

.issues-app-chat-sidebar-comments {
  height: 520px;
  border: 1px solid rgba(0, 0, 0, .2);

  &__label {
    display: block;
    font-weight: 500;
    margin-top: 15px;
  }

  &__toolbar {
    border-bottom: 1px solid rgba(0, 0, 0, .2);
    height: 55px;
    padding: 10px;


    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: auto;

      &:hover {
        cursor: pointer;
        color: rgba(var(--app-success), 1);
      }
    }
  }

  .ql-toolbar.ql-snow {
    border: none;
    display: flex;
    align-items: center;
    padding: 0;
  }

  .ql-container.ql-snow {
    border: none;
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
  }

  .quill-editor {
    height: calc(100% - 55px);
  }

  .ql-editor {
    line-height: 1.1;
    padding: 0 10px;

    p {
      margin: 10px 0px;
    }
  }

  .ql-editor.ql-blank::before {
    top: 10px;
  }
}
</style>
